import type { IconName } from './types'
import { useIconContext } from './IconProvider'

interface Props {
  name: IconName
  size?: number
  className?: string
  style?: React.CSSProperties
  stroke?: number
  onClick?: (e: React.MouseEvent) => void
}

export function Icon({ name, size = 16, className, style, stroke, onClick }: Props) {
  const { pack, fallbackPack, strokeWidth } = useIconContext()

  const IconComponent = pack[name]
    ?? fallbackPack?.[name]
    ?? pack['alert-circle']

  if (!IconComponent) return null

  return (
    <IconComponent
      size={size}
      className={className}
      style={{ strokeWidth: stroke ?? strokeWidth, ...style }}
      onClick={onClick}
    />
  )
}
